import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css'
import { CustomBrowserRouter } from './Route/CustomBrowserRouter';
import { GoogleOAuthProvider } from '@react-oauth/google';
// Put any other imports below so that CSS from your
// components takes precedence over default styles.
import './Media.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <GoogleOAuthProvider clientId="370019064160-u6t9ulh42e8in1sohde7h3au6f2kgup0.apps.googleusercontent.com">
  <GoogleOAuthProvider clientId="294430602405-huam62m4l0vg5ouq9bb3ht8nq06mdpis.apps.googleusercontent.com">
    <React.StrictMode>
      {/* @ts-ignore */}
      <CustomBrowserRouter>
        <App />
      </CustomBrowserRouter>
    </React.StrictMode>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
